import { create } from 'zustand';

/** Free OpenSeaMap seamark symbol overlay on/off, persisted per device. */
const KEY = 'los.seamarkOverlay';

function load(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

interface SeamarkState {
  on: boolean;
  toggle: () => void;
  /** Set explicitly (spec 17: applying a synced settings doc needs a real
   *  setter, not just toggle — mirrors the persist-then-set pattern above). */
  setOn: (on: boolean) => void;
}

export const useSeamarkStore = create<SeamarkState>((set, get) => ({
  on: load(),
  toggle: () => {
    get().setOn(!get().on);
  },
  setOn: (on) => {
    try {
      localStorage.setItem(KEY, on ? '1' : '0');
    } catch {
      /* ignore */
    }
    set({ on });
  },
}));
